export type Theme = 'light' | 'dark';

export const useThemeState = () => {
  const theme = useState<Theme>('theme', () => 'light');

  const setTheme = (newTheme: Theme) => {
    theme.value = newTheme;
  };

  const isDark = computed(() => theme.value === 'dark');
  const isLight = computed(() => theme.value === 'light');

  return {
    theme: readonly(theme),
    setTheme,
    isDark,
    isLight,
  };
};

